/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespFollowTopButton_user = {
    readonly serviceId: string | null;
    readonly favorites: {
        readonly " $fragmentRefs": FragmentRefs<"FollowButton_favoritesConnection">;
    } | null;
    readonly " $refType": "SbRespFollowTopButton_user";
};
export type SbRespFollowTopButton_user$data = SbRespFollowTopButton_user;
export type SbRespFollowTopButton_user$key = {
    readonly " $data"?: SbRespFollowTopButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowTopButton_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchPages"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespFollowTopButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "kind": "LinkedField",
      "name": "favorites",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FollowButton_favoritesConnection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'fbd99f4fb8eee2fd288b7ba28ed992ec';
export default node;
